import { render, staticRenderFns } from "./AddFlatCodesWizardControl.global.vue?vue&type=template&id=8468636e&lang=pug&"
import script from "./AddFlatCodesWizardControl.global.vue?vue&type=script&lang=ts&"
export * from "./AddFlatCodesWizardControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports